import _toConsumableArray from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import { isFalsyOrEmpty } from '../../../base/common/arrays.js';
import { Schemas } from '../../../base/common/network.js';
import { URI } from '../../../base/common/uri.js';
import { Event, Emitter } from '../../../base/common/event.js';
import { MarkerSeverity } from './markers.js';
import { ResourceMap } from '../../../base/common/map.js';
import { Iterable } from '../../../base/common/iterator.js';

var DoubleResourceMap = /*#__PURE__*/function () {
  function DoubleResourceMap() {
    _classCallCheck(this, DoubleResourceMap);

    this._byResource = new ResourceMap();
    this._byOwner = new Map();
  }

  _createClass(DoubleResourceMap, [{
    key: "set",
    value: function set(resource, owner, value) {
      var ownerMap = this._byResource.get(resource);

      if (!ownerMap) {
        ownerMap = new Map();

        this._byResource.set(resource, ownerMap);
      }

      ownerMap.set(owner, value);

      var resourceMap = this._byOwner.get(owner);

      if (!resourceMap) {
        resourceMap = new ResourceMap();

        this._byOwner.set(owner, resourceMap);
      }

      resourceMap.set(resource, value);
    }
  }, {
    key: "get",
    value: function get(resource, owner) {
      var ownerMap = this._byResource.get(resource);

      return ownerMap === null || ownerMap === void 0 ? void 0 : ownerMap.get(owner);
    }
  }, {
    key: "delete",
    value: function _delete(resource, owner) {
      var removedA = false;
      var removedB = false;

      var ownerMap = this._byResource.get(resource);

      if (ownerMap) {
        removedA = ownerMap.delete(owner);
      }

      var resourceMap = this._byOwner.get(owner);

      if (resourceMap) {
        removedB = resourceMap.delete(resource);
      }

      if (removedA !== removedB) {
        throw new Error('illegal state');
      }

      return removedA && removedB;
    }
  }, {
    key: "values",
    value: function values(key) {
      var _a, _b, _c, _d;

      if (typeof key === 'string') {
        return (_b = (_a = this._byOwner.get(key)) === null || _a === void 0 ? void 0 : _a.values()) !== null && _b !== void 0 ? _b : Iterable.empty();
      }

      if (URI.isUri(key)) {
        return (_d = (_c = this._byResource.get(key)) === null || _c === void 0 ? void 0 : _c.values()) !== null && _d !== void 0 ? _d : Iterable.empty();
      }

      return Iterable.map(Iterable.concat.apply(Iterable, _toConsumableArray(this._byOwner.values())), function (map) {
        return map[1];
      });
    }
  }]);

  return DoubleResourceMap;
}();

var MarkerStats = /*#__PURE__*/function () {
  function MarkerStats(service) {
    _classCallCheck(this, MarkerStats);

    this.errors = 0;
    this.infos = 0;
    this.warnings = 0;
    this.unknowns = 0;
    this._data = new ResourceMap();
    this._service = service;
    this._subscription = service.onMarkerChanged(this._update, this);
  }

  _createClass(MarkerStats, [{
    key: "dispose",
    value: function dispose() {
      this._subscription.dispose();
    }
  }, {
    key: "_update",
    value: function _update(resources) {
      var _iterator = _createForOfIteratorHelper(resources),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var resource = _step.value;

          var oldStats = this._data.get(resource);

          if (oldStats) {
            this._substract(oldStats);
          }

          var newStats = this._resourceStats(resource);

          this._add(newStats);

          this._data.set(resource, newStats);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "_resourceStats",
    value: function _resourceStats(resource) {
      var result = {
        errors: 0,
        warnings: 0,
        infos: 0,
        unknowns: 0
      }; // TODO this is a hack

      if (resource.scheme === Schemas.inMemory || resource.scheme === Schemas.walkThrough || resource.scheme === Schemas.walkThroughSnippet) {
        return result;
      }

      var _iterator2 = _createForOfIteratorHelper(this._service.read({
        resource: resource
      })),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var severity = _step2.value.severity;

          if (severity === MarkerSeverity.Error) {
            result.errors += 1;
          } else if (severity === MarkerSeverity.Warning) {
            result.warnings += 1;
          } else if (severity === MarkerSeverity.Info) {
            result.infos += 1;
          } else {
            result.unknowns += 1;
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return result;
    }
  }, {
    key: "_substract",
    value: function _substract(op) {
      this.errors -= op.errors;
      this.warnings -= op.warnings;
      this.infos -= op.infos;
      this.unknowns -= op.unknowns;
    }
  }, {
    key: "_add",
    value: function _add(op) {
      this.errors += op.errors;
      this.warnings += op.warnings;
      this.infos += op.infos;
      this.unknowns += op.unknowns;
    }
  }]);

  return MarkerStats;
}();

export var MarkerService = /*#__PURE__*/function () {
  function MarkerService() {
    _classCallCheck(this, MarkerService);

    this._onMarkerChanged = new Emitter();
    this.onMarkerChanged = Event.debounce(this._onMarkerChanged.event, MarkerService._debouncer, 0);
    this._data = new DoubleResourceMap();
    this._stats = new MarkerStats(this);
  }

  _createClass(MarkerService, [{
    key: "dispose",
    value: function dispose() {
      this._stats.dispose();
    }
  }, {
    key: "remove",
    value: function remove(owner, resources) {
      var _iterator3 = _createForOfIteratorHelper(resources || []),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var resource = _step3.value;
          this.changeOne(owner, resource, []);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "changeOne",
    value: function changeOne(owner, resource, markerData) {
      if (isFalsyOrEmpty(markerData)) {
        // remove marker for this (owner,resource)-tuple
        var removed = this._data.delete(resource, owner);

        if (removed) {
          this._onMarkerChanged.fire([resource]);
        }
      } else {
        // insert marker for this (owner,resource)-tuple
        var markers = [];

        var _iterator4 = _createForOfIteratorHelper(markerData),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var data = _step4.value;

            var marker = MarkerService._toMarker(owner, resource, data);

            if (marker) {
              markers.push(marker);
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this._data.set(resource, owner, markers);

        this._onMarkerChanged.fire([resource]);
      }
    }
  }, {
    key: "read",
    value: function read() {
      var filter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.create(null);
      var owner = filter.owner,
          resource = filter.resource,
          severities = filter.severities,
          take = filter.take;

      if (!take || take < 0) {
        take = -1;
      }

      if (owner && resource) {
        // exactly one owner AND resource
        var data = this._data.get(resource, owner);

        if (!data) {
          return [];
        } else {
          var result = [];

          var _iterator5 = _createForOfIteratorHelper(data),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var marker = _step5.value;

              if (MarkerService._accept(marker, severities)) {
                var newLen = result.push(marker);

                if (take > 0 && newLen === take) {
                  break;
                }
              }
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          return result;
        }
      } else if (!owner && !resource) {
        // all
        var _result = [];

        var _iterator6 = _createForOfIteratorHelper(this._data.values()),
            _step6;

        try {
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            var markers = _step6.value;

            var _iterator7 = _createForOfIteratorHelper(markers),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _data = _step7.value;

                if (MarkerService._accept(_data, severities)) {
                  var _newLen = _result.push(_data);

                  if (take > 0 && _newLen === take) {
                    return _result;
                  }
                }
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }

        return _result;
      } else {
        // of one resource OR owner
        var iterable = this._data.values(resource !== null && resource !== void 0 ? resource : owner);

        var _result2 = [];

        var _iterator8 = _createForOfIteratorHelper(iterable),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var _markers = _step8.value;

            var _iterator9 = _createForOfIteratorHelper(_markers),
                _step9;

            try {
              for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                var _data2 = _step9.value;

                if (MarkerService._accept(_data2, severities)) {
                  var _newLen2 = _result2.push(_data2);

                  if (take > 0 && _newLen2 === take) {
                    return _result2;
                  }
                }
              }
            } catch (err) {
              _iterator9.e(err);
            } finally {
              _iterator9.f();
            }
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        return _result2;
      }
    }
  }], [{
    key: "_toMarker",
    value: function _toMarker(owner, resource, data) {
      var code = data.code,
          severity = data.severity,
          message = data.message,
          source = data.source,
          startLineNumber = data.startLineNumber,
          startColumn = data.startColumn,
          endLineNumber = data.endLineNumber,
          endColumn = data.endColumn,
          relatedInformation = data.relatedInformation,
          tags = data.tags;

      if (!message) {
        return undefined;
      } // santize data


      startLineNumber = startLineNumber > 0 ? startLineNumber : 1;
      startColumn = startColumn > 0 ? startColumn : 1;
      endLineNumber = endLineNumber >= startLineNumber ? endLineNumber : startLineNumber;
      endColumn = endColumn > 0 ? endColumn : startColumn;
      return {
        resource: resource,
        owner: owner,
        code: code,
        severity: severity,
        message: message,
        source: source,
        startLineNumber: startLineNumber,
        startColumn: startColumn,
        endLineNumber: endLineNumber,
        endColumn: endColumn,
        relatedInformation: relatedInformation,
        tags: tags
      };
    }
  }, {
    key: "_accept",
    value: function _accept(marker, severities) {
      return severities === undefined || (severities & marker.severity) === marker.severity;
    }
  }, {
    key: "_debouncer",
    value: function _debouncer(last, event) {
      if (!last) {
        MarkerService._dedupeMap = new ResourceMap();
        last = [];
      }

      var _iterator10 = _createForOfIteratorHelper(event),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var uri = _step10.value;

          if (!MarkerService._dedupeMap.has(uri)) {
            MarkerService._dedupeMap.set(uri, true);

            last.push(uri);
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      return last;
    }
  }]);

  return MarkerService;
}();